module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/dtg-794e5edf342e9992a1bab2cdf4ac55f4.svg";